import { t } from 'i18next';
import { useCallback, useState } from 'react';

import useLatestRequestSignal from '~hooks/useLatestRequestSignal/useLatestRequestSignal';
import { ServiceClass } from '~hooks/useServiceClass/models';
import useServiceClass from '~hooks/useServiceClass/useServiceClass';
import connection from '~services/connectionModule';

export default function useServiceClassOptions() {
  const { getServiceClassesByCompanyId } = useServiceClass();
  const [serviceClassOptions, setServiceClassOptions] = useState<ServiceClass[]>([]);
  const issueRequestSignal = useLatestRequestSignal();

  const loadServiceClassOptions = useCallback(
    async (companyId: string) => {
      const signal = issueRequestSignal();
      setServiceClassOptions([]);

      try {
        const { data } = await getServiceClassesByCompanyId(companyId, { signal });
        if (signal.aborted) return;

        setServiceClassOptions(data);
      } catch (error) {
        if (signal.aborted) return;

        try {
          connection.handleRequestError(
            error,
            t('error_messages.service_classes.failed_to_fetch'),
          );
        } catch {
          // handleRequestError already showed the toast
        }
      }
    },
    [getServiceClassesByCompanyId, issueRequestSignal],
  );

  return { loadServiceClassOptions, serviceClassOptions };
}
